import { __assign, __extends, __rest } from "tslib";
/* eslint-disable prettier/prettier */
import React from 'react';
import { utils, defaultStyles } from 'pro-gallery-lib';
import ProGallery from './proGallery/proGallery';
import basePropTypes from './proGallery/propTypes';
var BaseGallery = /** @class */ (function (_super) {
    __extends(BaseGallery, _super);
    function BaseGallery(props) {
        var _this = _super.call(this, props) || this;
        _this.id = props.id || 'default-dom-id';
        _this.customComponents = props.customComponents || {};
        return _this;
    }
    BaseGallery.prototype.render = function () {
        var _a = this.props, styles = _a.styles, options = _a.options, styleParams = _a.styleParams, eventsListener = _a.eventsListener, otherProps = __rest(_a, ["styles", "options", "styleParams", "eventsListener"]);
        var _eventsListener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return typeof eventsListener === 'function' && eventsListener.apply(void 0, args);
        };
        var _styles = __assign(__assign(__assign(__assign({}, defaultStyles), options), styles), styleParams); //TODOVER3 can we remove the default styles?? blueprints should take care of it
        var galleryProps = __assign(__assign({}, otherProps), { styles: _styles, eventsListener: _eventsListener, id: this.id, customComponents: this.customComponents });
        utils.logPlaygroundLink(galleryProps.styles);
        if (galleryProps.styles &&
            galleryProps.items &&
            galleryProps.container &&
            galleryProps.structure) {
            return React.createElement(ProGallery, __assign({}, galleryProps));
        }
        else {
            return null;
        }
    };
    BaseGallery.propTypes = basePropTypes;
    return BaseGallery;
}(React.Component));
export default BaseGallery;
/* eslint-enable prettier/prettier */
//# sourceMappingURL=rendererIndex.js.map